import { FC, useContext, useEffect } from 'react';

import ReactQuill from 'react-quill';

import { Formulario } from 'view/component/Formulario/Formulario';
import { UsuarioLogadoContext } from 'view/component/UsuarioLogadoContext/UsuarioLogadoContext';
import { useFocus } from 'util/useFocus';
import { ComentarioCamposFormulario } from './NovoComentarioCamposFormulario';
import { validadorNovoComentarioFormulario } from '../../../../business/validacao/ValidadorNovoComentarioFormulario';

import { useDispatch, useSelector } from 'react-redux';
import { ComentariosSolicitacaoSelector } from 'store/ComentariosSolicitacao/ComentariosSolicitacao.selector';
import { ComentariosSolicitacaoAction } from 'store/ComentariosSolicitacao/ComentariosSolicitacao.action';
import { NovoComentarioTagProps } from './NovoComentarioTag';
import styled from 'styled-components';
import { Spacing } from 'styles/theme/Tema';
import { SolicitacaoAtividadeEsqueleto } from 'view/component/SolicitacaoAtividade/SolicitacaoAtividade';
import { NovoComentarioTagConteudoFormulario } from './NovoComentarioTagConteudoFormulario';
import { FormikHelpers } from 'formik';
import { OperacaoFormularioCRUD } from 'service/restricao/OperacaoFormulario/OperacaoFormulario';
import { useAppDispatch } from 'store/store';


export const NovoComentarioTagFormulario: FC<NovoComentarioTagProps> = ({solicitacao, onSalvo}) => {
  const dispatch = useAppDispatch();

  const usuarioLogado = useContext(UsuarioLogadoContext).usuarioLogado;
  const emEdicao = useSelector(ComentariosSolicitacaoSelector.novo.isEmEdicao);
  const [editorRef, setInputFocus] = useFocus<ReactQuill>();

  const placeholder = "Adicionar comentário...";
  const onSubmit = async (formulario: ComentarioCamposFormulario, { resetForm }: FormikHelpers<ComentarioCamposFormulario>) => {
    const comentario = await dispatch(ComentariosSolicitacaoAction.criacao.persistir(solicitacao.id!!, formulario)).unwrap();

    onSalvo(comentario);
    resetForm();
  }

  useEffect(() => {emEdicao && setInputFocus()}, [emEdicao, setInputFocus]);

  return <FormularioContainer
    formik={{ initialValues: {"comentario": {"mensagem": undefined, "anexos": []}}, onSubmit: onSubmit, validate: validadorNovoComentarioFormulario}}
    operacao={OperacaoFormularioCRUD.Criar}
    >
    <SolicitacaoAtividadeEsqueleto ancora="solicitacao-novo-comentario" pessoa={usuarioLogado}>
      {!emEdicao && <NovoComentarioTagHabilitador placeholder={placeholder} />}
      { emEdicao && <NovoComentarioTagConteudoFormulario name="comentario" placeholder={placeholder} ref={editorRef} />}
    </SolicitacaoAtividadeEsqueleto>
  </FormularioContainer>
}



interface NovoComentarioTagHabilitadorProps {
  placeholder: string
}

const NovoComentarioTagHabilitador: FC<NovoComentarioTagHabilitadorProps> = ({placeholder}) => {
  const dispatch = useDispatch();
  const habilitarEdicao = () => dispatch(ComentariosSolicitacaoAction.criacao.iniciar());

  return <input onClick={habilitarEdicao} onFocus={habilitarEdicao} placeholder={placeholder} />
}


const FormularioContainer = styled(Formulario)`
  padding: ${Spacing.unit}px 0 0 0;
  margin-bottom: ${Spacing.unit/2}px;
  background: ${({theme}) => theme.background.nivel_1};
  border-bottom: 1px solid ${({theme}) => theme.background.borda};
`;